import { render, staticRenderFns } from "./CopyClipboard.vue?vue&type=template&id=0728f004&lang=html&"
import script from "./CopyClipboard.vue?vue&type=script&lang=js&"
export * from "./CopyClipboard.vue?vue&type=script&lang=js&"
import style0 from "./CopyClipboard.vue?vue&type=style&index=0&id=0728f004&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports